import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
const Sidebar = () => {
  const { pathname } = useLocation()
  const { officer_type, user_type_value } = useSelector((state) => state?.auth?.auth);
  let Menus
  if (user_type_value === "employee") {
    Menus = [
      {
        path: '/app/propertyreport',
        key: ['propertyreport'],
        title: 'Property Report',
        icon: 'upload'
      },
      {
        path: '/app/dashboard',
        key: ['dashboard'],
        title: 'Dashboard',
        icon: 'grid_view'
      },
      {
        path: '/app/Staff/Staffleaveapply',
        key: ['Staff/Staffleaveapply'],
        title: 'Apply Leave',
        icon: 'person_edit'
      },
      {
        path: '/app/Staff/Staffleavestatus',
        key: ['Staffleavestatus', 'StaffSpecificView'],
        title: 'Leave History',
        icon: 'history'
      }
    ];
    if (officer_type === "supporting_staff") {
      Menus.push({
        path: '/app/Staff/Staffcompoff',
        key: ['Staffcompoff'],
        title: 'Comp Off',
        icon: 'edit_document'
      });
    } else if (officer_type === "faculty") {
      Menus.push(
        {
          path: '/app/Staff/StaffActivityReportPage',
          key: ['StaffActivityReportPage', 'StaffActivityReport', 'StaffOverallreport', 'StaffSavedReport'],
          title: 'Appraisal Report',
          icon: 'lab_profile'
        },
        {
          path: '/app/Staff/StaffScoreReport',
          key: ['StaffScoreReport'],
          title: 'Score Report',
          icon: 'readiness_score'
        },
        {
          path: '/app/Staff/StaffPerformanceReport',
          key: ['StaffPerformanceReport', 'StaffPerformanceSpecificReport', 'StaffPerformanceSpecificViewReport'],
          title: 'Performance Scoreboard Fixed',
          icon: 'track_changes'
        }
      );
    }
  } else if (user_type_value === "hod") {
    Menus = [
      {
        path: '/app/Hod/HodLeaverequest',
        key: ['HodLeaverequest', "HodSpecificrequestview"],
        title: 'Leave Request',
        icon: 'patient_list'
      },
      {
        path: '/app/Hod/HodEmployeeList',
        key: ['HodEmployeeList', 'HodEmployeeSpecificView'],
        title: 'Staff List',
        icon: 'group'
      },
      {
        path: '/app/Hod/HodCompoffLeaverequest',
        key: ['HodCompoffLeaverequest', 'HodSpecificComprequestview'],
        title: 'Comp Off Leave Request',
        icon: 'user_attributes'
      },
      {
        path: '/app/Hod/HodReportlist',
        key: ['HodReportlist'],
        title: 'Appraisel Report',
        icon: 'summarize'
      },
      {
        path: '/app/Hod/HodIndentformrequest',
        key: ['HodIndentformrequest'],
        title: 'Indent Form Request',
        icon: 'table_rows'
      },
      {
        path: '/app/Hod/HodScoreReport',
        key: ['HodScoreReport'],
        title: 'Performance Report Generate',
        icon: 'problem'
      },
      {
        path: '/app/Hod/StaffPerformanceReport',
        key: ['StaffPerformanceReport','HodPerformancereportspecificview'],
        title: 'Performance Scoreboard Fixed',
        icon: 'track_changes'
      },
      {
        path: '/app/Hod/AnnualPerformanceAssessmentReport',
        key: ['AnnualPerformanceAssessmentReport'],
        title: 'Annual Performance Assessment Report',
        icon: 'library_books'
      }
    ];
  } else if (user_type_value === "admin") {
    Menus = [
      {
        path: '/app/admin/propertyreturnsreport',
        key: ['propertyreturnsreport'],
        title: 'Property Report',
        icon: 'upload'
      },
      {
        path: '/app/admin/AdminLeaverequest',
        key: ['AdminLeaverequest'],
        title: 'Leave Request',
        icon: 'patient_list'
      },
      {
        path: '/app/admin/AdminEmployeeList',
        key: ['AdminEmployeeList'],
        title: 'Staff List',
        icon: 'group'
      },
      {
        path: '/app/admin/AdminCompoffLeaverequest',
        key: ['AdminCompoffLeaverequest', 'AdminSpecificComprequestview'],
        title: 'Comp Off Leave Request',
        icon: 'user_attributes'
      },
      {
        path: '/app/admin/AdminReportlist',
        key: ['AdminReportlist'],
        title: 'Appraisel Report',
        icon: 'summarize'
      },
      {
        path: '/app/admin/AdminScoreReport',
        key: ['AdminScoreReport'],
        title: 'Performance Report Generate',
        icon: 'problem'
      },
      {
        path: '/app/admin/StaffPerformanceReport',
        key: ['StaffPerformanceReport'],
        title: 'Performance Scoreboard Fixed',
        icon: 'track_changes'
      },
      {
        path: '/app/admin/AnnualPerformanceAssessmentReport',
        key: ['AnnualPerformanceAssessmentReport'],
        title: 'Annual Performance Assessment Report',
        icon: 'library_books'
      }
    ];
  } else if (user_type_value === "director") {
    Menus = [
      {
        path: '/app/dashboard',
        key: ['dashboard'],
        title: 'Dashboard',
        icon: 'grid_view'
      },
      {
        path: '/app/Director/DirectorLeaverequest',
        key: ['DirectorLeaverequest'],
        title: 'Leave Request',
        icon: 'patient_list'
      },
      {
        path: '/app/Director/DirectorEmployeeList',
        key: ['DirectorEmployeeList'],
        title: 'Staff List',
        icon: 'group'
      },
      {
        path: '/app/Director/DirectorCompoffLeaverequest',
        key: ['DirectorCompoffLeaverequest', 'DirectorSpecificComprequestview'],
        title: 'Comp Off Leave Request',
        icon: 'user_attributes'
      },
      {
        path: '/app/Director/DirectorIndentlistrequest',
        key: ['DirectorIndentlistrequest'],
        title: 'Indent Form Request',
        icon: 'table_rows'
      },
      {
        path: '/app/Director/DirectorReportlist',
        key: ['DirectorReportlist'],
        title: 'Appraisel Report',
        icon: 'summarize'
      },
      {
        path: '/app/Director/DirectorScoreReport',
        key: ['DirectorScoreReport'],
        title: 'Performance Report Generate',
        icon: 'problem'
      },
      {
        path: '/app/Director/StaffPerformanceReport',
        key: ['StaffPerformanceReport'],
        title: 'Performance Scoreboard Fixed',
        icon: 'track_changes'
      },
      {
        path: '/app/Director/AnnualPerformanceAssessmentReport',
        key: ['AnnualPerformanceAssessmentReport'],
        title: 'Annual Performance Assessment Report',
        icon: 'library_books'
      }
    ];
  } else if (user_type_value === "system_admin") {
    Menus = [
      {
        path: '/app/Systemadmin/Masterdata',
        key: ['Masterdata'],
        title: 'Master Data',
        icon: 'lan'
      },
      {
        path: '/app/Systemadmin/SystemadminEmployeeList',
        key: ['SystemadminEmployeeList'],
        title: 'Staff List',
        icon: 'group'
      }
    ];
  } else if (user_type_value === "indent") {
    Menus = [
      {
        path: '/app/Indent/IndentApplication',
        key: ['IndentApplication'],
        title: 'Staff List',
        icon: 'summarize'
      }
    ];
  } else if (user_type_value === "store_incharge") {
    Menus = [
      {
        path: '/app/Stores/StoreMaster',
        key: ['StoreMaster'],
        title: 'Master Data',
        icon: 'lan'
      },
      {
        path: '/app/Stores/StoreInchargeIndentList',
        key: ['StoreInchargeIndentList'],
        title: 'Staff List',
        icon: 'summarize'
      }
    ];
  }


  return (
    <>
      <div className="sidebar scrollbox">
        <ul className="">
          {Menus?.map((item, i) => {
            return (
              <li className="marginspace" key={i}>
                <Link to={item?.path}>
                  <div title={item?.title}>
                    <span
                      className={`material-symbols-outlined 
                      ${item?.key?.some(word => pathname.includes(word)) ? 'sidebarnavactive' : 'sidebarnavinactive'}`}
                    >{item?.icon}</span>
                  </div>
                </Link>
              </li>
            )
          })
          }
        </ul>
      </div>
    </>
  );
};

export default Sidebar;